
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use environment variable for URL if available, otherwise fallback to hardcoded value
const SUPABASE_URL = import.meta.env?.VITE_SUPABASE_URL || 'https://ddiciudsdsxmiokufeky.supabase.co';
// Use environment variable for anonymous key if available, otherwise fallback to hardcoded value
const SUPABASE_PUBLISHABLE_KEY = import.meta.env?.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkaWNpdWRzZHN4bWlva3VmZWt5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU5OTY0NTAsImV4cCI6MjA2MTU3MjQ1MH0.bRJcuuNo12RxOuh2a5IX8TMV2Wz80uffEm8Va6K6CrQ';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'reelatlas-auth-token',
  },
});
